import React from 'react';
import { CalendarIcon } from '@heroicons/react/24/outline';

const SchedulingChannels = ({ channels, activeChannelId, onSelect, loading }) => {
  if (loading) {
    return (
      <nav className="w-full lg:w-64 lg:shrink-0 border-r bg-white">
        <div className="p-4 animate-pulse space-y-2">
          <div className="h-4 bg-gray-200 rounded w-3/4"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
        </div>
      </nav>
    );
  }

  return (
    <nav className="w-full lg:w-64 lg:shrink-0 border-b lg:border-r lg:border-b-0 bg-white flex flex-col max-h-48 lg:max-h-none">
      {/* Compliance Warning */}
      <div className="p-3 sm:p-4 text-xs sm:text-sm text-amber-900 bg-amber-50 border-b">
        <div className="font-semibold mb-1">⚠️ Scheduling Only</div>
        <div className="text-xs hidden sm:block">
          No deliberations or votes. Use noticed meetings for decisions.
        </div>
      </div>

      {/* Channels List */}
      <div className="flex-1 overflow-x-auto lg:overflow-y-auto p-2">
        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wider px-3 py-2 hidden lg:block">
          Channels
        </div>
        {channels.length === 0 ? (
          <div className="px-3 py-4 text-xs sm:text-sm text-gray-500 whitespace-nowrap">
            No channels available. Creating...
          </div>
        ) : (
          <ul className="flex lg:flex-col gap-2 lg:space-y-1 lg:gap-0">
            {channels.map(ch => (
              <li key={ch.id} className="shrink-0">
                <button
                  className={`whitespace-nowrap lg:w-full text-left px-3 py-2 rounded-lg transition-colors flex items-center gap-2 text-sm ${
                    ch.id === activeChannelId
                      ? 'bg-blue-50 text-blue-700 font-medium'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                  onClick={() => onSelect(ch)}
                >
                  <CalendarIcon className="h-4 w-4 shrink-0" />
                  <span className="truncate">{ch.name}</span>
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </nav>
  );
};

export default SchedulingChannels;
